export const AVATARS = [
    {
        avatar_id: "197c26578aee4ad1bda7629022c2f49b",
        name: "Torsunov",
        label: "Torsunov",
    },
];

export const STT_LANGUAGE_LIST = [
    { label: "English", value: "en", key: "en" },
    { label: "Russian", value: "ru", key: "ru" },
];
